import React from 'react';
import {Table} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {i18nizeDate} from '../helpers/Utils';
import Rbac from '../components/Rbac';
import KycDetailsMetaInfo from './KycDetailsMetaInfo';

class KycDetails extends React.Component {
  render() {
    const {t, kycInfo, itemIndex, showKycFeedbackForm} = this.props;
    const {userId, id, feedback, evaluatorFirstName, evaluatorLastName, evaluatorUsername, createdAt} = kycInfo;
    return (
      <div className="table-row-sub pt-2">
        <Table bordered responsive>
          <tbody>
          {!!feedback && <tr>
            <td style={{width: 150}} className="text-info">{t('Feedback')}</td>
            <td className='d-flex flex-row align-items-center border-bottom-0 border-right-0'>
              <span>{feedback}</span>
              <Rbac permission="update_user-kyc">
                <i className='icon-Pencil cursor-pointer text-large text-primary mx-1'
                   onClick={() => {showKycFeedbackForm({id}, feedback, itemIndex);}}/>
              </Rbac>
            </td>
          </tr>}
          {!!evaluatorUsername && <tr>
            <td style={{width: 150}} className="text-info">{t('Evaluated By')}</td>
            <td>{`${evaluatorFirstName ? `${evaluatorFirstName} ${evaluatorLastName} ` : ''}[${evaluatorUsername}]`}</td>
          </tr>}
          <tr>
            <td style={{width: 150}} className="text-info">{t('Register Date')}</td>
            <td>{i18nizeDate(createdAt)}</td>
          </tr>
          </tbody>
        </Table>
        <KycDetailsMetaInfo
          userId={userId}
          kycInfo={kycInfo}
        />
      </div>
    );
  }
}

export default withTranslation()(KycDetails);